import styles from './googleMap.module.css'
import { APIProvider, Map, MapCameraChangedEvent } from "@vis.gl/react-google-maps"
import { googleMapsKey, googleMapsMapId } from "../../../../services/constants"
import { GoogleMapContent } from './googleMapContent'
import { useCallback, useState } from 'react'
import { MapImg } from '../../constants'
import { AddressData, RouteDuration } from './types'

type Props = {
    addressesData: AddressData[]
    onChangeRoute?: (sortedAddressesData: AddressData[], duration: RouteDuration) => void
}

export const GoogleMap = (props: Props) => {
    const { addressesData, onChangeRoute } = props

    const [zoom, setZoom] = useState<number>(12)

    const onDrag = useCallback((e: MapCameraChangedEvent) => {
        const { detail } = e
        setZoom(detail.zoom)
    }, [])

    return (
        <div className={styles.container}>
            <APIProvider apiKey={googleMapsKey}>
                <div className={styles.mapContainer}>
                    {addressesData.length > 0 ? (
                        <Map
                            mapId={googleMapsMapId}
                            zoom={zoom}
                            clickableIcons={false}
                            gestureHandling="greedy"
                            fullscreenControl={false}
                            onCameraChanged={onDrag}
                        >
                            <GoogleMapContent
                                addressesData={addressesData}
                                onChangeRoute={onChangeRoute}
                            />
                        </Map>
                    ) : (
                        <div className={styles.placeholder}>
                            <img src={MapImg} alt="Map" width={150} height={150} />
                        </div>
                    )}
                </div>
            </APIProvider>
        </div>
    )
}
